import type { NavigateOptions } from 'react-router-dom'

import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'

const navigationState: {
  navigate?: (path: string, options?: NavigateOptions) => void
  replace: (path: string) => void
  location?: {
    pathname: string
    search: string
    hash: string
    state: unknown
  }
} = {
  navigate: undefined,
  replace: (path) => window.location.replace(path),
  location: undefined,
}

const navigateToApplication = (path: string) => {
  window.location.assign(path)
}

const useRouter = () => {
  const { push, openInNewTab } = useAppNavigation()

  return {
    push,
    navigate: (path: string) => {
      push(path, { includeOrgPrefix: true })
    },
    openInNewTab: (path: string, includeOrgPrefix: boolean = true) => {
      openInNewTab(path, { includeOrgPrefix })
    },
  }
}

export { useRouter, navigationState, navigateToApplication }
